<div class="searchPanel">
	<form [formGroup]="formCtlSelectSchoolDistrict" class="formSelectSchoolDistrict">
		<div class="row">
            <span class="formatFilterHeader">
	                Filter&nbsp;&nbsp;
            </span>
            <span class="col-12 col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 inputWrapper">
				<input id="txtFilter" type="text" matInput type="text" formControlName="txtFilter"
						name="txtFilter" placeholder="{{filterPlaceholder}}" class="txtFilterCss"
						(keyup)="applyFilter($event)" #input>
			</span>
			<span class="col-12 col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 buttonWrapper" >
				<button mat-raised-button color="secondary" aria-label="Clear" (click)="fnReset()"
					[disabled]="!canClearFilter" matTooltip="Clear filter">
					<i class="material-icons" style="transform: translateY(-5px);"><span class="material-icons make-white">delete_forever</span></i>
				</button>&nbsp;&nbsp;
			</span>
		</div>
	</form>
</div>
<div class="margin-top-sm">
	<div class="floatCreate">
		<button mat-raised-button matTooltip="Create new school district"
							(click)="fnCreate()" class="btnRaise"  color="primary"
							*ngIf="featurePermissions['Search School Districts']">
							<ng-container *ngIf="!bCancelCreate">
								<mat-icon class="iconDisplay">edit</mat-icon>
							</ng-container>&nbsp;{{createBtnText}}
						</button>
	</div>	
	<h2>{{txtSearchResultsTitle}}</h2>
	<mat-table id="districtsTable" [dataSource]="tableDataSource" class="table-responsive" matSort
		(matSortChange)="announceSortChange($event)"> 
		<ng-container *ngIf="showViewIcon" matColumnDef="selectView">
			<th class="midHeader" mat-header-cell *matHeaderCellDef></th>
			<td class="flushUp" mat-cell *matCellDef="let element;let i = index"
				>
				<ng-container *ngIf="showViewIcon">
					<span class="raiseEditIcon">
					<button mat-icon-button color="primary" (click)="openDialog(element)" matTooltip="View School District"
						[matTooltipPosition]="position.value!">						
							<mat-icon style="transform: translateY(-2px);">remove_red_eye</mat-icon>
					</button>
					</span>
					<span class="raiseEditIcon">
                        <button mat-icon-button color="primary" (click)="edit(element)"  matTooltip="Edit School" [matTooltipPosition]="position.value!">
                            <mat-icon style="transform: translateX(2px) translateY(-1px);">edit</mat-icon>
                        </button>
                    </span>
				</ng-container>
				<!-- <span *ngIf="results[i]?.ID" [hidden]="bHideColID">R: {{results[i]?.ID}}</span> -->
			</td>
		</ng-container>
		<ng-container matColumnDef="REGIONS.CODE">
			<th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:20px;"> Region </th>
			<td class="flushUpHovers" mat-cell *matCellDef="let element;let i = index"
				>				
				<button mat-icon-button color="primary" (mouseover)="onFocus($event, element.REGIONS.NAME, 1)"
					matTooltip="{{customHoverMessage}}" [matTooltipPosition]="position.value!">
					<span style='font-size:14px;'>{{element.REGIONS?.CODE}}</span>
				</button>
			</td>
		</ng-container>
		<ng-container matColumnDef="COUNTy.COUNTY_CODE">
			<th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:20px;"> County </th>
			<td class="flushUpHovers" mat-cell *matCellDef="let element;let i = index"
				>
				<button mat-icon-button color="primary" (mouseover)="onFocus($event, element.COUNTy.COUNTY_NAME, 1)"
					matTooltip="{{customHoverMessage}}" [matTooltipPosition]="position.value!">
					<span style='font-size:14px;'>{{element.COUNTy?.COUNTY_CODE}}</span>
				</button>				
			</td>
		</ng-container>
		<ng-container matColumnDef="DISTRICTS">
			<th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:40px;"> School District Name </th>
			
			<td class="flushUp" mat-cell *matCellDef="let element; let i = index;"
				[class.row-is-clicked]="fnCheckRow(element,i)">
				{{element.DISTRICTS | titlecase}}
			</td>
		</ng-container>
		<ng-container matColumnDef="CODE">
			<th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:30px;"> School District Code </th>
			<td class="flushUp" mat-cell *matCellDef="let element;let i = index">
				{{element.CODE}}
			</td>
		</ng-container>
		<ng-container matColumnDef="NCESDist">
			<th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:20px;"> NCES</th>
			<td class="flushUp" mat-cell *matCellDef="let element;let i = index">
				{{element.NCESDist}}
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let i = index; let row; columns: displayedColumns;"></tr>
	</mat-table>
</div>
<mat-paginator #myPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page">
</mat-paginator>